import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, Renderer2 } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppConstants } from 'src/app/classes/app/constants';
import { IonContent, IonHeader, ModalController, Platform } from '@ionic/angular';
import { INavParams, IViewSpecs } from 'src/app/classes/def/nav-params/general';
import { ThemeColors } from 'src/app/classes/def/app/theme';
import { ETutorialEntries, Messages } from 'src/app/classes/def/app/messages';
import { IPopoverActions } from 'src/app/classes/def/app/modal-interaction';
import { EModalTypes } from 'src/app/classes/utils/uiext';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { AnalyticsService } from 'src/app/services/general/apis/analytics';
import { BackButtonService } from 'src/app/services/general/ui/back-button';
import { ResourcesCoreDataService } from 'src/app/services/data/resources-core';
import { SettingsManagerService } from 'src/app/services/general/settings-manager';
import { ERouteDef } from 'src/app/app-utils';
import { NavParamsService, INavParamsInfo } from 'src/app/services/app/nav-params';
import { ENavParamsResources } from 'src/app/classes/def/nav-params/resources';
import { UiExtensionStandardService } from 'src/app/services/general/ui/ui-extension-standard';
import { EAppIcons, EAppIconsStandard, EImgIcons, EPhotos } from 'src/app/classes/def/app/icons';
import { ActivatedRoute, NavigationExtras, Params, Router } from '@angular/router';
import { PopupFeaturesService } from 'src/app/services/app/modules/minor/popup-features';
import { DomSanitizer, Meta, SafeHtml } from '@angular/platform-browser';
import { ITutorial } from 'src/app/classes/def/app/tutorials';
import { FileManagerService } from 'src/app/services/media/file';
import { Util } from 'src/app/classes/general/util';
import { IFaqCategory } from 'src/app/classes/def/support/support';
import { EFAQCategories, SupportDataService } from 'src/app/services/data/support';
import { EmailFormatUils } from 'src/app/services/utils/email-format';
import { IUnlockContentCheckoutParams, IUnlockContentCheckoutReturnData, UnlockContentCheckoutComponent } from 'src/app/modals/app/modals/unlock-content-checkout/unlock-content-checkout.component';
import { ISupportNavParams } from 'src/app/classes/def/nav-params/support';
import { StoryDataService } from 'src/app/services/data/story';
import { IStoryResponse } from 'src/app/classes/def/core/story';
import { InventoryDataService } from 'src/app/services/data/inventory';
import { IGameItem } from 'src/app/classes/def/items/game-item';
import { FAQListComponent, IFAQListParams } from 'src/app/modals/app/modals/faq-list/faq-list.component';
import { IDistFlags } from 'src/app/classes/def/app/app';
import { MarketplaceDataService } from 'src/app/services/data/marketplace';
import { IBookingInfoContent } from 'src/app/classes/def/core/booking';
import { EAlertButtonCodes } from 'src/app/classes/def/app/ui';
import { IMarketplaceDetailNavParams } from 'src/app/classes/def/nav-params/marketplace';
import { IEditorOpt, IEditorSettings } from 'src/app/classes/def/core/editor';
import { ErrorMessage } from 'src/app/classes/general/error-message';
import { EBookingCheckAction, IBookingCheckReturn } from 'src/app/components/app/components/booking-check/booking-check.component';

@Component({
    selector: 'app-support',
    templateUrl: './support.page.html',
    styleUrls: ['./support.page.scss'],
    animations: [
        trigger('showState', [
            state('inactive', style({
                // transform: 'translateY(-100%)',
                opacity: 0
            })),
            state('active', style({
                // transform: 'translateY(0)',
                opacity: 1
            })),
            transition('inactive => active', animate(AppConstants.animationMode)),
            transition('active => inactive', animate(AppConstants.animationMode))
        ])
    ],
    encapsulation: ViewEncapsulation.None
})
export class SupportPage implements OnInit, OnDestroy {
    @ViewChild("header", { read: IonHeader, static: false }) header: HTMLElement;
    @ViewChild("content", { read: IonContent, static: false }) content: HTMLElement;

    website: string = AppConstants.links.website;
    testFlightUrl: string = AppConstants.links.testFlightUrl;
    appStoreUrl: string = AppConstants.links.appStoreUrl;
    playStoreUrl: string = AppConstants.links.playStoreUrl;
    webUrl: string = AppConstants.links.webUrl;
    webUrlDisp: string = AppConstants.links.webUrlDisp;

    photoUrl: string = EPhotos.balloonLandscape;

    title: string = "Support";

    np: INavParams = null;
    vs: IViewSpecs;
    isModal: boolean = false;

    params: ISupportNavParams;

    tutorialVideoUrl: string = null;
    tutorialVideoExtUrlMobile: string = null;

    extDataLoaded: boolean = false;
    faqCategories: IFaqCategory[];

    linkPreview: boolean = false;

    token: string = null;
    unlockCodeGranted: string = null;
    storyId: number = null;

    theme: string = "theme-light theme-light-bg";

    isCheckout: boolean = false;
    loaded: boolean = true;
    isDelete: boolean = false;
    isBookingCode: boolean = false;

    bookingReferenceInfo: string = "";
    bookingReferenceInfoIcon: string = null;

    bookingReference: string = "";
    bookingPrefix: string = "";

    bookingProvider: number = null;
    bookingProviderOTAs: IEditorOpt[] = null;

    settings: IEditorSettings;

    infoText = {
        reviewContact: null,
        howItWorks: null,
        reviewContactIcon: null,
        howItWorksIcon: null,
        appNotes: null,
        testFlightNotes: null,
        webNotes: null,
        appStoreNotes: null,
        playStoreNotes: null,
        connectHeader: null,
        connectNotes: null
    };

    distInit: IDistFlags = {
        android: true,
        ios: true,
        mobile: true,
        web: true
    };

    imgIcons = EImgIcons;
    isTestFlightOnly: boolean = false;

    dist: IDistFlags = {

    } as IDistFlags;

    appIcons = EAppIcons;
    appIconsStandard = EAppIconsStandard;

    faqActivation: IFaqCategory = null;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public uiext: UiExtensionService,
        public uiextStandard: UiExtensionStandardService,
        public plt: Platform,
        public analytics: AnalyticsService,
        public backButton: BackButtonService,
        public resourcesProvider: ResourcesCoreDataService,
        public settingsProvider: SettingsManagerService,
        public modalCtrl: ModalController,
        public nps: NavParamsService,
        public popupFeatures: PopupFeaturesService,
        public domSanitizer: DomSanitizer,
        public fileManager: FileManagerService,
        public renderer: Renderer2,
        public support: SupportDataService,
        public storyDataService: StoryDataService,
        public inventoryDataService: InventoryDataService,
        public marketplaceDataService: MarketplaceDataService,
        public meta: Meta
    ) {
        // customize default values of carousels used by this component tree
        // carouselConfig.interval = 2000;
        // carouselConfig.keyboard = true;
        // carouselConfig.pauseOnHover = true;
    }

    resetDistFlags() {
        this.dist = Object.assign({}, this.distInit);
    }


    // in my case i'm using ionViewWillEnter
    ionViewWillEnter() {
        console.log("will enter");
        this.renderer.setStyle(this.header['el'], 'webkitTransition', 'top 300ms');
        this.renderer.setStyle(this.content['el'], 'webkitTransition', 'top 300ms');
    }

    onContentScroll(event) {
        let target = event.target;
        let offsetHeader: number = 56;
        let offsetContent: number = 26;
        if (target.scrollTop >= 50) {
            this.renderer.setStyle(this.header['el'], 'top', '-' + offsetHeader + 'px');
            this.renderer.setStyle(this.content['el'], 'top', '-' + offsetContent + 'px');
        } else {
            this.renderer.setStyle(this.header['el'], 'top', '0px');
            this.renderer.setStyle(this.content['el'], 'top', '0px');
        }
    }

    updateMetadata() {
        // this.meta.updateTag({ property: 'og:title', content: 'YOUR_TITLE' });
        // this.meta.updateTag({ property: 'og:image', content: 'YOUR_IMAGE' });
        this.meta.updateTag({ property: 'og:url', content: 'https://connect.leplace.online/support' });
    }


    async loadExtData() {
        try {
            this.loaded = false;
            let cats: IFaqCategory[] = await this.support.getFaqV2([EFAQCategories.stories, EFAQCategories.app, EFAQCategories.activation]);
            this.faqCategories = cats.filter(c => c.code !== EFAQCategories.activation);
            this.faqActivation = cats.find(c => c.code === EFAQCategories.activation);
            this.extDataLoaded = true;

            // cache all tutorials before loading
            await this.resourcesProvider.getInfoDataMultiCache([
                ETutorialEntries.reviewContact,
                ETutorialEntries.howItWorks,
                ETutorialEntries.appNotes,
                ETutorialEntries.testFlightNotes,
                ETutorialEntries.webNotes
            ], true);

            let tutorial: ITutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.reviewContact, true);
            this.infoText.reviewContact = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
            this.infoText.reviewContactIcon = tutorial.photoUrl;

            tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.howItWorks, true);
            this.infoText.howItWorks = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);
            this.infoText.howItWorksIcon = tutorial.photoUrl;

            tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.appNotes, true);
            this.infoText.appNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

            tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.testFlightNotes, true);
            this.infoText.testFlightNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

            tutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.webNotes, true);
            this.infoText.webNotes = this.domSanitizer.bypassSecurityTrustHtml(tutorial.description);

            this.infoText.appStoreNotes = "<p>App Store release might not be available in your country. In that case, please use TestFlight or web app following the instructions below.</p>";
            this.infoText.playStoreNotes = "<p>Play Store release is not officially available in your country. Please use the web app instead.</p>";

            this.infoText.connectHeader = "<p>This is the Connect page for your tour</p>";
            this.infoText.connectNotes = "<p>Check out the instructions below for accessing the tour available in our app</p>";

            this.settings = await this.marketplaceDataService.loadSettings();
            this.bookingProviderOTAs = [{
                name: "Any",
                value: null,
                description: null
            } as IEditorOpt].concat(this.settings.bookingOTAs.filter(ota => ota.description != null)); // keep only options with prefix

            this.loaded = true;
        } catch (err) {
            this.loaded = true;
            this.analytics.dispatchError(err, "support");
            console.error(err);
        }
    }

    selectProvider() {
        console.log("select provider: ", this.bookingProvider);
        let opt: IEditorOpt = this.bookingProviderOTAs.find(bp => bp.value === this.bookingProvider);
        console.log("provider: ", opt);
        let prefix: string = opt?.description;
        this.bookingPrefix = prefix;
    }

    nop() {

    }

    async loadDeleteInfo() {
        try {
            let category: number = EFAQCategories.account;
            let cats: IFaqCategory[] = await this.support.getFaqV2([category]);
            let params: IFAQListParams = {
                title: "Account deletion",
                faqCategories: cats
            };
            this.uiext.showCustomModal(null, FAQListComponent, {
                view: {
                    fullScreen: false,
                    transparent: AppConstants.transparentMenus,
                    large: true,
                    addToStack: true,
                    frame: false
                },
                params: params
            }).then((res: number) => {
                console.log(res);
            }).catch((err: Error) => {
                console.error(err);
            });
        } catch (err) {
            this.analytics.dispatchError(err, "content");
            console.error(err);
        }
    }

    bookingCheckAction(data: IBookingCheckReturn) {
        if (!data) {
            return;
        }
        switch (data.action) {
            case EBookingCheckAction.openStoryPage:
                this.openStoryPage(data.data.storyId, data.data.token, data.data.unlockCodes);
                break;
        }
    }

    openStoryPage(storyId: number, token: string, unlockCodes: string[]) {
        let params: IMarketplaceDetailNavParams = {
            storyId: storyId,
            fromMarket: false,
            reload: true,
            unlockCodes: unlockCodes
        };

        if (token != null) {
            params.token = token;
        }

        let navParams: INavParams = {
            view: null,
            storyId: storyId,
            token: token,
            params: params
        };

        this.nps.set(ENavParamsResources.marketplaceContent, navParams);
        let extras: NavigationExtras = {
            replaceUrl: true,
            queryParams: {
                storyId: storyId,
                token: token
            }
        };
        this.router.navigate([ERouteDef.storyline], extras);
    }

    loadCheckoutInfo() {
        this.resourcesProvider.getInfoData(ETutorialEntries.checkoutNote, true).then(async (tutorial: ITutorial) => {
            let description: string = "<p>Your request has been processed</p>";
            if (this.params.unlockUserId != null) {
                description += "<p>New content has been unlocked on your Leplace account</p>";
            }
            if (this.params.unlockStoryId != null) {
                let story: IStoryResponse = await this.storyDataService.getStoryFromServer(this.params.unlockStoryId, null, null);
                description += "<p>> Unlocked storyline: " + story.story.name + "</p>";
            }
            if (this.params.unlockItemCode != null) {
                let item: IGameItem = await this.inventoryDataService.getItemSpec(this.params.unlockItemCode);
                description += "<p>> Unlocked item: " + item.name + "</p>";
            }

            let params: IUnlockContentCheckoutParams = {
                title: tutorial.title,
                description: description,
                descriptionFooter: null,
                iconDescription: tutorial.photoUrl,
                iconFooter: tutorial.photoUrlIos,
                unlockCodes: [this.unlockCodeGranted]
            };
            this.uiext.showCustomModal(null, UnlockContentCheckoutComponent, {
                view: {
                    fullScreen: false,
                    transparent: AppConstants.transparentMenus,
                    large: true,
                    addToStack: true,
                    frame: false
                },
                params: params
            }).then((res: number) => {
                console.log(res);
            }).catch((err: Error) => {
                console.error(err);
            });
        }).catch((err) => {
            console.error(err);
            this.analytics.dispatchError(err, "support");
        });
    }

    initFlags() {
        this.resetDistFlags();
        this.isTestFlightOnly = this.dist.mobile && !this.dist.ios;
    }

    ngOnInit() {
        this.updateMetadata();
        this.analytics.trackView("support");
        this.nps.checkParamsLoaded().then(() => {
            let npInfo: INavParamsInfo = this.nps.getCombined(ENavParamsResources.support, null, this.np);
            console.log("nav params: ", npInfo.params);
            let npar = npInfo.params;

            let hasParams: boolean = npInfo.hasParams;
            let promiseParams: Promise<boolean> = new Promise((resolve) => {
                if (hasParams) {
                    console.log(npar);
                    let np: INavParams = npar;
                    if (np && np.params) {
                        this.params = np.params;
                        this.token = this.params.token;
                    }
                    this.vs = np.view;
                    this.isModal = this.vs ? this.vs.isModal : false;
                    this.linkPreview = false;
                    this.initFlags();
                    resolve(true);
                } else {
                    this.storyId = 0;
                    this.route.queryParams.subscribe((params: Params) => {
                        if (params) {
                            let data: ISupportNavParams = params as any;
                            this.params = Object.assign({}, data);
                            this.token = this.params.token;
                            this.unlockCodeGranted = this.params.unlock;
                            this.isCheckout = this.params.checkout as any === "true";
                            this.isDelete = this.params.delete as any === "true";
                            this.isBookingCode = this.params.booking as any === "true";
                            this.params.storyId = this.params.storyId != null ? Number.parseInt(this.params.storyId as any) : null;
                            this.params.unlockUserId = this.params.unlockUserId != null ? Number.parseInt(this.params.unlockUserId as any) : null;
                            this.params.unlockStoryId = this.params.unlockStoryId != null ? Number.parseInt(this.params.unlockStoryId as any) : null;
                            this.params.unlockItemCode = this.params.unlockItemCode != null ? Number.parseInt(this.params.unlockItemCode as any) : null;
                            console.log("parsed params: ", this.params);
                            this.initFlags();
                        }
                        resolve(true);
                    });
                }
            });
            promiseParams.then(() => {
                this.storyId = this.params.storyId;
                // can be opened either as a modal or a root page
                this.plt.ready().then(() => {
                    this.backButton.pushOrReplace(() => {
                        this.back();
                    }, this.vs);
                }).catch((err: Error) => {
                    console.error(err);
                });

                this.settingsProvider.getSettingsLoaded(false).then((res) => {
                    if (res) {
                        this.theme = ThemeColors.theme[SettingsManagerService.settings.app.settings.theme.value].css;
                        this.loadAll();
                    }
                }).catch((err: Error) => {
                    console.error(err);
                });
            });
        }).catch((err: Error) => {
            console.error(err);
        });

    }



    loadAll() {
        this.loadExtData();
        this.loadTutorialVideoLink();
        if (this.isCheckout) {
            this.loadCheckoutInfo();
        }
        if (this.isDelete) {
            this.loadDeleteInfo();
        }
        // if (this.isBookingCode) {
        //     this.loadBookingCodeInfo();
        // }
    }

    loadTutorialVideoLink() {
        this.resourcesProvider.getInfoData(ETutorialEntries.storylineTutorialVideo, true).then((tutorial: ITutorial) => {
            // this.tutorialEmbedPDFLink = this.domSanitizer.bypassSecurityTrustResourceUrl(tutorial.description);
            this.tutorialVideoUrl = tutorial.description;
            this.tutorialVideoExtUrlMobile = tutorial.photoUrlIos;
        }).catch((err: Error) => {
            console.error(err);
            this.analytics.dispatchError(err, "content");
        });
    }

    ngOnDestroy() {
        this.backButton.checkPop(this.vs);
    }

    swipeEvent(e) {
        this.backButton.handleSwipeEvent(e);
    }


    /**
     * back to story list
     * @param animate 
     */
    back() {
        if (this.isModal) {
            this.dismissModal();
        } else {
            // let navParams: INavParams = {
            //   view: null,
            //   params: params
            // };
            // this.nps.set(ENavParamsResources.marketplaceBrowse, navParams);
            // this.router.navigate([ERouteDef.marketplace], { replaceUrl: true }).then(() => {
            // }).catch((err: Error) => {
            //   console.error(err);
            // });

            let navParams: INavParams = {
                view: null,
                params: null
            };
            this.nps.set(ENavParamsResources.home, navParams);
            this.router.navigate([ERouteDef.home], { replaceUrl: true }).then(() => {
            }).catch((err: Error) => {
                console.error(err);
            });
        }
    }

    /**
     * return from modal
     * load story flag shows if the map should load the current story
     * @param animate 
     * @param loadStory 
     */
    dismissModal() {
        setTimeout(() => {
            this.modalCtrl.dismiss().then(() => {
            }).catch((err: Error) => {
                console.error(err);
            });
        }, 1);
    }

    presentPopover() {
        let actions: IPopoverActions = {};
        actions = {
            reload: {
                name: "Reload",
                code: 2,
                icon: EAppIconsStandard.refresh,
                enabled: true
            }
        };

        this.uiextStandard.showStandardModal(null, EModalTypes.options, null, {
            view: {
                fullScreen: false,
                transparent: AppConstants.transparentMenus,
                large: true,
                addToStack: true,
                frame: false
            },
            params: { actions: actions }
        }).then((code: number) => {
            switch (code) {
                case 2:
                    this.loadAll();
                    break;
                default:
                    break;
            }
        }).catch((err: Error) => {
            console.error(err);
        });
    }

    onZoomImage(_zoom: boolean) {
        // this.zoomState = zoom;
    }

    getPlaceDetails(index) {
        console.log(index);
    }

    isAppStore() {
        return this.dist.ios && !this.isTestFlightOnly;
    }

    goToAppStore() {
        Util.openURLAdaptive(this.appStoreUrl);
    }

    goToAppleTestFlight() {
        Util.openURLAdaptive(this.testFlightUrl);
    }

    goToPlayStore() {
        Util.openURLAdaptive(this.playStoreUrl);
    }

    goToWeb() {
        // url += "/#/story-home?storyId=" + this.storyId;
        Util.openURLAdaptive(this.webUrl);
    }

    openWebpage() {
        Util.openURLAdaptive(this.website);
    }

    /**
    * open app FB page
    */
    openFBPage() {
        // Util.openURLAdaptive(this.appDetails.fbLink);
        Util.openURLAdaptive("https://www.facebook.com/leplaceglobal/");
    }

    /**
     * write email to developers
     */
    contact() {
        // let link: string = this.appDetails.contactEmail;
        let link: string = "office@leplace.online";
        if (link) {
            link = "mailto:" + link;
            let subject = "Visitor contact from LP Connect";
            let body = "";
            let uri: string = EmailFormatUils.formatExistingContent(link, subject, body);
            // Util.openURLAdaptive(uri);
            this.fileManager.openURLAsAnchor(uri);
        }
    }

    copyToClipboard(code: string) {
        this.popupFeatures.copyToClipboard(code);
    }
}

